module.exports = __webpack_public_path__ + "static/media/valvula-seg-01.c1d89a38.jpg";